export default "__VITE_ASSET__BYNReFfP__"